import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import './show-goback.scss';

class BoardGoback extends React.Component {
  static displayName = 'BoardGoback';

  static propTypes = {
    gobackAction: React.PropTypes.func.isRequired,
    title: React.PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const { gobackAction, title } = this.props;
    return (
      <div className="o-fz--13 goback goback--modify" onTouchTap={gobackAction}>{title}</div>
    );
  }
}

export default BoardGoback;



// WEBPACK FOOTER //
// ./src/component/mui/show-board/show-goback.jsx